import type { ReactElement } from 'react';
import { useI18n } from '../../lib/i18n/I18nProvider';
import { Card, PageTitle } from '../../ui/primitives';
import { ApproverDesk, AuditStatement } from '../../ui/guards';
import { Ltr } from '../../ui/primitives';

/**
 * `SHR-11`'s second half, as a place rather than a field.
 *
 * The whole point of four eyes is that the second principal is a DIFFERENT PRINCIPAL, so the
 * approval cannot be produced from inside the initiator's session — and this screen is what a
 * second principal opens in their own. It is deliberately reachable on its own URL, because the
 * approver typically is not sitting at the initiator's machine: they open `/admin/approvals` in
 * their own browser, signed in as themselves, and paste the hand-off request they were sent.
 *
 * `POST /v1/approvals` then holds them to everything the act itself is held to: the action's
 * permission for that expo, and their own step-up window. Nothing on this page can be filled in by
 * the initiator, and nothing on the initiator's page can be filled in by the approver.
 */
export function AdminApprovals(): ReactElement {
  const { t } = useI18n();
  return (
    <>
      <PageTitle title={t('admin.approvals.title')}>{t('admin.approvals.desc')}</PageTitle>
      <Card title={t('approval.desk.title')}>
        <AuditStatement>
          <p>
            The approval is recorded against <Ltr>your</Ltr> user, for the initiator you name, and
            the server refuses it if the two are the same principal or if you do not hold the
            action&rsquo;s permission in the scope the aggregate belongs to.
          </p>
        </AuditStatement>
        <ApproverDesk />
      </Card>
    </>
  );
}
